import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CustomisableSection } from '@shared/models/customisable-section';
import { CustomisableVariables } from '@shared/models/customisable-variables';
import { MenuList } from '@shared/models/menu-list';
import { CustomisableVariablesService } from '@shared/services/customisable-variables.service';
import { SiteSettingsService } from '@shared/services/site-settings.service';
import { AccessibleClickDirective } from '@shared/shared/directives/accessible-click.directive';
import { ISiteSettings, PlatformProviderType } from '@shared/shared/interfaces/site-settings.interfaces';
import { LanguageService } from '@shared/shared/services/language-service';
import { RecaptchaService } from '@shared/shared/services/recaptcha.service';
import { SiteMap, SitemapService } from '@shared/shared/services/sitemap.service';
import { NavigationService } from 'core/services/navigation.service';
import { Observable } from 'rxjs';
import { map, shareReplay, startWith, switchMap } from 'rxjs/operators';
import { CustomisableSectionsService } from '../../../shared/shared/services/customisable-sections.service';
import { FooterComponent } from '../footer/footer.component';

@Component({
  selector: 'ten-concierge-footer',
  templateUrl: './ten-concierge-footer.component.html',
  styleUrls: ['./ten-concierge-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, AsyncPipe, FooterComponent, NgFor, RouterModule, AccessibleClickDirective, TranslateModule, NgClass],
})
export class TenConciergeFooterComponent implements OnInit {
  public platformProviderTypes = PlatformProviderType;
  public siteSettings$: Observable<ISiteSettings>;
  public isReCaptchaFooter$: Observable<boolean>;
  public footerSection$: Observable<CustomisableSection>;
  public reCaptchaSection$: Observable<CustomisableSection>;
  public customVariables$: Observable<CustomisableVariables> = this.customVariablesService.variables;
  public mainNavLinks$: Observable<MenuList[]>;
  public siteMap$: Observable<SiteMap>;
  public secondaryMenuList$: Observable<MenuList[]>;

  @Input() public dcrCookieLanguage = 'en-gb';

  @Input() public userAuthenticated$: Observable<boolean>;

  constructor(
    private customisableSectionsService: CustomisableSectionsService,
    private siteSettingsService: SiteSettingsService,
    private languageService: LanguageService,
    private reCaptchaService: RecaptchaService,
    private router: Router,
    private customVariablesService: CustomisableVariablesService,
    private sitemapService: SitemapService,
    private navigationService: NavigationService
  ) {
    this.isReCaptchaFooter$ = this.reCaptchaService.getReCaptcha();
    this.siteSettings$ = this.siteSettingsService.fetchSiteSettings();
    this.siteMap$ = this.sitemapService.siteMap$;
    this.mainNavLinks$ = this.navigationService.getNavigationLinks();
    this.secondaryMenuList$ = this.navigationService.getNavigationLinks('footer');
  }

  public ngOnInit() {
    const sections$ = this.languageService.languageUpdated.pipe(
      startWith(''),
      switchMap(() => {
        return this.customisableSectionsService.getCustomisableSections(['footercontent', 'recaptcha_banner']);
      }),
      shareReplay(1)
    );

    this.isReCaptchaFooter$ = this.reCaptchaService.getReCaptcha();
    this.footerSection$ = sections$.pipe(map((sections) => (sections ? sections[0] : null)));
    this.reCaptchaSection$ = sections$.pipe(map((sections) => (sections ? sections[1] : null)));
  }

  public navigate(link: string) {
    this.router.navigate([link]);
  }
}
